import { Injectable } from '@angular/core';
import { FirebaseX, IChannelOptions } from '@awesome-cordova-plugins/firebase-x/ngx';
import { Intercom } from '@awesome-cordova-plugins/intercom/ngx';
import { Platform } from '@ionic/angular';
import firebase from 'firebase/app';

import { FirebaseService } from '../firebase/firebase.service';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsService {

  firestore: firebase.firestore.Firestore;

  constructor(
    private firebaseNative: FirebaseX,
    private platform: Platform,
    private firebaseService: FirebaseService,
    private intercom: Intercom) { }

  async getToken() {
    let token;
    if (this.platform.is('android')) {
      if (!(await this.firebaseNative.hasPermission())) {
        this.firebaseNative.grantPermission()
            .then(async () => token = await this.firebaseNative.getToken());
      } else {
        token = await this.firebaseNative.getToken();
      }
    } else if (this.platform.is('ios')) {
      if (!(await this.firebaseNative.hasPermission())) {
        this.intercom.registerForPush();
        this.firebaseNative.grantPermission()
        .then(async () => token = await this.firebaseNative.getToken());
      }
      token = await this.firebaseNative.getToken();
    }
    this.firebaseNative.setDefaultChannel({
      visibility: 0,
      importance: 4,
    } as IChannelOptions);

    this.firebaseNative.onTokenRefresh().subscribe((newToken) => {
      this.saveTokenToFirestore(newToken);
    });

    return this.saveTokenToFirestore(token);
  }

  private saveTokenToFirestore(token: string) {
    if (!token) {
      return;
    }
    const deviceRef = this.firebaseService.getCollection('devices');
    return this.firebaseService.updateDocumentWithMerge({token}, deviceRef, token);
  }

  listenToNotifications() {
    return this.firebaseNative.onMessageReceived();
  }

}
